import { motion } from 'framer-motion';

const projects = [
  {
    title: 'M2 Air Solution',
    metric: '124 inbound leads in 30 days',
    summary: 'Launched a high-velocity Google Ads + landing page combo that filled their install calendar.',
    image: require('../assets/m2air.png'),
    url: 'https://m2airsolution.com',
  },
  {
    title: 'PSA Toronto',
    metric: '63 paid trials in two weeks',
    summary: 'Rebuilt the site UX and spun up Meta remarketing flows that cut cost per sign-up by 54%.',
    image: require('../assets/psa.png'),
    url: 'https://psatoronto.net',
  },
];

export default function Projects({ onTalkClick }) {
  return (
    <section id="work" className="bg-white py-20">
      <div className="mx-auto max-w-6xl px-6">
        <div className="flex flex-col gap-4 text-center md:flex-row md:items-end md:justify-between md:text-left">
          <div>
            <p className="text-sm uppercase tracking-[0.2em] text-slate-500">Case studies</p>
            <h2 className="mt-2 text-3xl font-semibold text-slate-900 md:text-4xl">Recent plays still driving revenue</h2>
            <p className="mt-4 max-w-2xl text-slate-600">These are full-funnel builds we shipped in the last few months.</p>
          </div>
          <button
            type="button"
            onClick={() => onTalkClick?.()}
            className="inline-flex items-center justify-center rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white shadow hover:opacity-90"
          >
            Book a project review →
          </button>
        </div>

        <div className="mt-12 grid gap-8 md:grid-cols-2">
          {projects.map((project, index) => (
            <motion.a
              key={project.title}
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-lg"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.15 }}
              viewport={{ once: true, amount: 0.2 }}
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col gap-3 border-t border-slate-200 bg-gradient-to-r from-white to-slate-50 p-6">
                <h3 className="text-xl font-semibold text-slate-900">{project.title}</h3>
                <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">{project.metric}</p>
                <p className="text-sm text-slate-600">{project.summary}</p>
                <span className="mt-auto inline-flex items-center text-sm font-semibold text-blue-600 transition group-hover:text-blue-700">
                  View live project →
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
